import React, {useEffect, useRef, useState} from 'react';
import Product from "btdt/react/Product";
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import RestrictedNotice from "btdt/react/RestrictedNotice";
import LocationContact from "btdt/react/LocationContact";

export default function SizesStep({simpleMode, animating, chosenLocation, chosenProduct, preferredLocation, preferredProduct, projectType, projectSubType, handleProductChange, handleNextStep}) {

    const [swiper, setSwiper] = useState(null)

    // get products from chosen location
    let {products} = chosenLocation

    // add recommended status to each product based on the chosen project type and subtype
    products = products.map(p => {
        const hasType = projectType && p.tags.includes(projectType.id)
        const hasSubType = projectSubType && p.tags.includes(projectSubType.id)
        const recommended = (projectType && !projectSubType && hasType) || (projectType && projectSubType && hasSubType)
        return {...p, recommended}
    })

    // natural sort products by name
    const sorter = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
    products = products.sort(sorter.compare).reverse()

    // pull out the recommended product if it exists and move it to the front
    const recommendedIndex = products.findIndex(p => p.recommended)
    if (recommendedIndex > -1) {
        const recommendedProduct = products.at(recommendedIndex)
        products.splice(recommendedIndex, 1)
        products = [recommendedProduct, ...products]
    }

    const nextEl = useRef(null);
    const prevEl = useRef(null);

    useEffect(() => {
        // if there is a chosen product from the bin sizes page, and it doesn't match any products in the chosen location, unset the selection
        if (chosenProduct && products.findIndex(p => p.id === chosenProduct.id) === -1) {
            handleProductChange(null)
        }

    }, []);

    useEffect(() => {
        // auto slide to the chosen product if it has been pre-selected
        if (swiper && chosenProduct) {
            const index = products.findIndex(p => p.id === chosenProduct.id);
            swiper.slideToLoop(index || 0)
        }
    }, [swiper]);

    return (
        <>
            <div className={"container mx-auto px-4 lg:px-8"}>
                <div className={"grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6 mb-6"}>
                    {!simpleMode && (
                        <div className={"lg:col-span-8 lg:col-start-3"}>
                            <div className="large-p font-bold">
                                Available size options:
                            </div>

                            {chosenLocation && chosenLocation?.pricing_info && (
                                <ul>
                                    {chosenLocation.pricing_info.map(i => (
                                        <li>{i.line}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    )}
                    {!simpleMode && chosenLocation?.restricted && chosenLocation.restricted.length > 0 && (
                        <div className={"lg:col-span-8 lg:col-start-3"}>
                            <RestrictedNotice location={chosenLocation}/>
                        </div>
                    )}
                    { (preferredLocation && preferredLocation.hash !== chosenLocation.hash || (preferredProduct && !chosenProduct) ) && (
                        <div className={"lg:col-span-8 lg:col-start-3"}>
                            <p className={"font-bold"}>
                                <span className={"text-[#A70000]"}>BIN AVAILABILITY:</span> Because you have now been matched to your local Bin There Dump That, your
                                preferred dumpster size may not be available.
                            </p>
                        </div>
                    )}
                </div>

                <div className={"grid grid-cols-1 lg:grid-cols-12"}>
                    <div className={"relative lg:col-span-12"}>
                        <Swiper
                            spaceBetween={32}
                            slidesPerView={1.25}
                            loop={true}
                            centeredSlides={false}
                            modules={[Navigation]}
                            breakpoints={{
                                768: {
                                    slidesPerView: 2.25,
                                },
                                1024: {
                                    slidesPerView: 3,
                                }
                            }}
                            navigation={{
                                nextEl: nextEl.current,
                                prevEl: prevEl.current,
                            }}
                            onSwiper={setSwiper}
                        >
                            {products.map((product, index) => (
                                <SwiperSlide key={index} className={"!h-auto"}>
                                    <Product product={product} selectedProduct={chosenProduct} handleSelectedProduct={handleProductChange}/>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div ref={prevEl} className={"hidden lg:block w-7 h-[25px] absolute top-1/2 -translate-y-1/2 -left-7 cursor-pointer group"}>
                            <svg className="w-[14px] h-[25px] group-hover:fill-brand-blue">
                                <use xlinkHref="#chevron"></use>
                            </svg>
                        </div>
                        <div ref={nextEl} className={"hidden lg:flex w-7 h-[25px] absolute top-1/2 -translate-y-1/2 -right-7 cursor-pointer group justify-end"}>
                            <svg className="w-[14px] h-[25px] rotate-180 group-hover:fill-brand-blue">
                                <use xlinkHref="#chevron"></use>
                            </svg>
                        </div>
                    </div>
                </div>


                {!simpleMode && (
                    <div className={"grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6 mt-6"}>
                        <div className={"lg:col-span-8 lg:col-start-3"}>
                            <button className={"btn"} disabled={animating || chosenProduct === null} onClick={handleNextStep}>
                                Next Step →
                            </button>
                        </div>
                        <div className={"lg:col-span-8 lg:col-start-3"}>
                            <LocationContact location={chosenLocation}/>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}